import React from "react";
import FeaturesList from "./FeaturesList";
import WeatherForecast from "./WeatherForecast";

const BothyDetails = ({ bothy, weatherState, onClose }) => {
  const closestDistance = Number.isFinite(Number(bothy.closestDistance))
    ? `${Number(bothy.closestDistance).toFixed(1)}km`
    : null;

  const nearestRoadDistance = Number.isFinite(
    Number(bothy.nearestRoad?.distance)
  )
    ? `${Number(bothy.nearestRoad.distance).toFixed(1)}km away`
    : null;

  const nearestWebcamDistance = Number.isFinite(
    Number(bothy.nearestWebcam?.distanceKm)
  )
    ? `${Number(bothy.nearestWebcam.distanceKm).toFixed(1)}km away`
    : null;

  return (
    <div className="bothy-details">
      <div className="bothy-details__header">
        <div className="row">
          <p className="eyebrow">Selected bothy</p>
          <button className="icon-button" onClick={onClose} title="Close bothy">
            ✕
          </button>
        </div>
        <h2>{bothy.name}</h2>
        <div className="row">
          <button
            type="button"
            className="lede copyable copyable--inline"
            title="Copy grid reference"
            onClick={() => copyToClipboard(bothy.gridRef)}
          >
            {bothy.gridRef}
          </button>
          <button
            type="button"
            className="lede copyable copyable--inline"
            title="Copy lat/lon"
            onClick={() => copyCoords(bothy.lat, bothy.lon)}
          >
            {Number(bothy.lat).toFixed(4)}, {Number(bothy.lon).toFixed(4)}
          </button>
        </div>
      </div>

      <div className="metric-grid">
        <div className="metric-card">
          <span className="metric-card__label">Elevation</span>
          <div className="metric-card__value">{bothy.elevation} m</div>
        </div>
        <div className="metric-card">
          <span className="metric-card__label">Bortle</span>
          <div className="metric-card__value">
            {bothy.bortleClass || "Unknown"}
          </div>
        </div>
      </div>

      {(bothy.closestEntry || bothy.nearestRoad || bothy.nearestWebcam) && (
        <div className="nearest-list">
          <p className="eyebrow">Nearest</p>
          <ul>
            {bothy.closestEntry && (
              <li className="nearest-item">
                <span className="nearest-label">Other bothy</span>
                <span className="nearest-value">
                  {bothy.closestEntry || "Unknown"}
                  <span className="nearest-hint">{closestDistance || "—"}</span>
                </span>
              </li>
            )}
            {bothy.nearestRoad && (
              <li className="nearest-item">
                <span className="nearest-label">Road</span>
                <span className="nearest-value">
                  {bothy.nearestRoad.name || "Unknown"}
                  <span className="nearest-hint">
                    {nearestRoadDistance || "—"}
                  </span>
                </span>
              </li>
            )}
            {bothy.nearestWebcam && (
              <li className="nearest-item">
                <span className="nearest-label">Webcam</span>
                <span className="nearest-value">
                  {bothy.nearestWebcam.title || "Webcam"}
                  <span className="nearest-hint">
                    {nearestWebcamDistance || "—"}
                  </span>
                  {bothy.nearestWebcam.pageUrl && (
                    <a
                      href={bothy.nearestWebcam.pageUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                  )}
                </span>
              </li>
            )}
          </ul>
        </div>
      )}

      <div className="feature-block">
        <div>
          <p className="eyebrow">Bothy features</p>
          {Array.isArray(bothy.bothyFeatures) &&
          bothy.bothyFeatures.length > 0 ? (
            <div className="chip-row">
              {bothy.bothyFeatures.map(feature => (
                <span key={feature} className="chip">
                  {feature}
                </span>
              ))}
            </div>
          ) : (
            <p className="helper-text">No features listed</p>
          )}
        </div>
        <div>
          <p className="eyebrow">Landscape</p>
          <div className="chip-row chip-row--wrap">
            <FeaturesList features={bothy.features} />
          </div>
        </div>
      </div>

      {bothy.url && (
        <a
          href={bothy.url}
          target="_blank"
          rel="noopener noreferrer"
          className="ghost-button ghost-button--solid"
        >
          Open MBA entry
        </a>
      )}

      <WeatherForecast bothy={bothy} weatherState={weatherState} />
    </div>
  );
};

export default BothyDetails;

function copyToClipboard(text = "") {
  if (!text) return;
  if (navigator?.clipboard?.writeText) {
    navigator.clipboard.writeText(text).catch(() => {});
    return;
  }
  const temp = document.createElement("textarea");
  temp.value = text;
  temp.style.position = "fixed";
  temp.style.opacity = "0";
  document.body.appendChild(temp);
  temp.select();
  try {
    document.execCommand("copy");
  } catch (_) {
    // ignore
  }
  document.body.removeChild(temp);
}
const copyCoords = (lat, lon) => {
  const text = `${Number(lat).toFixed(6)}, ${Number(lon).toFixed(6)}`;
  if (navigator?.clipboard?.writeText) {
    navigator.clipboard.writeText(text).catch(() => {});
  } else {
    const temp = document.createElement("textarea");
    temp.value = text;
    temp.style.position = "fixed";
    temp.style.opacity = "0";
    document.body.appendChild(temp);
    temp.select();
    try {
      document.execCommand("copy");
    } catch (_) {
      // ignore
    }
    document.body.removeChild(temp);
  }
};
